import React from "react";
import "./trackRecord.css";
import building from "../../Common/buildings.json";
import { useState } from "react";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { useFetcher, useNavigate } from "react-router-dom";
import OurPortfolio from "../OurPortfolio/OurPortfolio";
import NavBar from "../../Layout/NavBar/NavBar";
import { useEffect } from "react";

const TrackRecord = (props) => {
  const navigate = useNavigate();
  const t = props.language;

  let assets = building.building;
  const allType = building.building.map((bld) => {
    return bld.Type;
  });
  const allUsage = building.building.map((bld) => {
    return bld.MainUse;
  });
  const uniqueType = [...new Set(allType)];
  const uniqueUsage = [...new Set(allUsage)];

  const [selectedAsset, setSelectedAsset] = useState(0);
  const [assetsObj, setAssetsObj] = useState({});

  const openMenu = props.openMenu;
  const onOpen = props.onOpen;

  const [filterT, setFilterT] = useState("");
  const [filterU, setFilterU] = useState("");

  const [originalAssets, setOriginalAssets] = useState(assets);
  const [onPage, setOnPage] = useState(false);
  useEffect(() => {
    setOnPage(true);
  }, []);
  // useEffect(() => {
  //   if (filterT) {
  //     setOriginalAssets(
  //       assets.filter((asset) => {
  //         console.log(asset.Type);
  //         return asset.Type === filterT;
  //       })
  //     );
  //   } else if (filterU) {
  //     setOriginalAssets(
  //       assets.filter((asset) => {
  //         console.log(asset.Type);
  //         return asset.Type === filterU;
  //       })
  //     );
  //   } else {
  //     setOriginalAssets(building.building);
  //   }
  // }, [filterT, filterU]);

  const [isProduct, setIsProduct] = useState(false);
  const [isUsage, setIsUsage] = useState(false);

  return (
    <div className="track-record">
      <NavBar
        language={props.language}
        languages={props.languages}
        openMenu={openMenu}
        onOpen={onOpen}
        black={true}
      />
      {!openMenu ? (
        <>
          <div className="filler"></div>
          {onPage ? (
            <OurPortfolio
              isInPage={true}
              language={props.language}
              languages={props.languages}
            />
          ) : (
            <></>
          )}

          {/* <div className="filter">
            <span className="span-filter">Filter By</span>
            <div className="button--1">
              <button
                className="button-filter"
                onClick={() => {
                  setIsProduct(!isProduct);
                  setIsUsage(false);
                }}
              >
                Product Type <IoIosArrowDown />
              </button>

              {isProduct ? (
                <div className="open__dropdown">
                  {uniqueType.map((type) => {
                    return (
                      <span
                        onClick={() => {
                          setFilterT(type);
                          setIsProduct(false);
                          setIsUsage(false);
                        }}
                      >
                        {type}
                      </span>
                    );
                  })}
                </div>
              ) : (
                <div></div>
              )}
            </div>

            <div className="button--2">
              <button
                className="button-filter"
                onClick={() => {
                  setOriginalAssets(assets);
                  setIsProduct(false);
                }}
              >
                Reset Filter
              </button>
            </div>
          </div> */}
          <div className="assets__container">
            {originalAssets.map((asset, index) => {
              return (
                <div
                  className="assets__map"
                  onMouseEnter={() => {
                    setAssetsObj({
                      [index + 1]: { entered: true },
                    });
                  }}
                  onMouseLeave={() => {
                    setAssetsObj({
                      [index + 1]: { entered: false },
                    });
                  }}
                >
                  <div className="assets__wrap">
                    <img
                      className="asset-img"
                      src={
                        asset?.name.includes("GRENELLE")
                          ? require(`../../Assets/Buildings/${asset.name}2.jpg`)
                          : require(`../../Assets/Buildings/${asset.name}1.jpg`)
                      }
                      alt=""
                      style={
                        assetsObj[index + 1]?.entered
                          ? { filter: "blur(4px)" }
                          : {}
                      }
                    />
                    {/* {assetsObj[index + 1]?.entered ? console.log(asset) : ""} */}
                    {assetsObj[index + 1]?.entered ? (
                      <div className="asset-description">
                        <h1 className="asset-title">{`${asset?.name}`}</h1>
                        <h3 className="asset-location">{asset?.location}</h3>
                        {/* <p className="asset-para">
                          Lorem ipsum dolor sit amet consectetur adipisicing
                          elit. Perspiciatis minima voluptates ex? Quos, sint
                          minus! Quidem ipsum repudiandae modi eveniet dolorum
                          eius incidunt deleniti esse quasi velit! Officia, a
                          nemo!
                        </p> */}
                        <button
                          className="asset-button"
                          onClick={() => {
                            navigate(
                              `/our-portfolio/${asset?.name.toLowerCase()}`
                            );
                          }}
                        >
                          {t("dm")} <IoIosArrowDown className="asset-arrow" />
                        </button>
                      </div>
                    ) : (
                      <div></div>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </>
      ) : (
        <div></div>
      )}
    </div>
  );
};

export default TrackRecord;
